import React from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import { DAILY_DEPOSIT_FILTERS_FORM_NAME } from 'Common/FormEnum';
import { DatePickerField, ButtonGroupField } from 'Common/SemanticWrapper';
import { DailyDepositFieldEnum as Fields } from 'Common/FieldEnum';
import { SiteComponent } from 'Common/SiteComponent';

import { MealTypeOptions } from '../helpers/DailyDepositHelpers';

const now = moment();

const FiltersForm = props => {
  const { loading, isFormDirty, showDirtyConfirm, change } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={4}>
            <Field
              label={'Date'}
              component={DatePickerField}
              name={Fields.Date}
              openToDate={now}
              maxDate={now}
              fluid
              formatOnBlur={false}
              onChange={(e, date) => {
                if (isFormDirty) {
                  e && e.preventDefault(); // prevent redux-form action from dispatching
                  showDirtyConfirm({
                    // show dirty confirm
                    closeModalYesCallback: () => {
                      // if the user clicks yes, now dispatch the change that was prevented
                      change(Fields.Date, date);
                    },
                  });
                }
              }}
            />
          </Grid.Column>
          <Grid.Column width={6}>
            <SiteComponent
              name={Fields.Site}
              isForm={true}
              isAllRequired={false}
              loading={loading}
              isPrimary={true}
              selectFirst={false}
              onChange={(site, preValue, field, e) => {
                if (isFormDirty) {
                  e && e.preventDefault();
                  showDirtyConfirm({
                    closeModalYesCallback: () => {
                      change(Fields.Site, site);
                    },
                  });
                }
              }}
            />
          </Grid.Column>
          <Grid.Column width={6} className="input-group--btn-group">
            <Field
              name={Fields.IsSupper}
              component={ButtonGroupField}
              label={'Meal Type'}
              fieldName={Fields.IsSupper}
              options={MealTypeOptions}
              onChange={(e, isSupper) => {
                if (isFormDirty) {
                  e && e.preventDefault();
                  showDirtyConfirm({
                    closeModalYesCallback: () => {
                      change(Fields.IsSupper, isSupper);
                    },
                  });
                }
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

const DailyDepositFilters = reduxForm({
  form: DAILY_DEPOSIT_FILTERS_FORM_NAME,
  destroyOnUnmount: false,
  onSubmit: () => {},
})(FiltersForm);

export { DailyDepositFilters };



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/components/DailyDepositFilters.js